module.exports = __webpack_public_path__ + "img/b_Mukoleks_left.48a2cabe.jpeg";